module.exports = __webpack_public_path__ + "img/facebook.6e3d26d7.svg";